<template>
  <div class="container">
    <div class="search text-center">
      <label class="checkbox-inline" v-for="(key, val) in searchConfig" track-by="$index">
        <input type="checkbox" @change="fetchList()" v-model="search.status" :value="key">{{val}}
      </label>
      <label class="checkbox-inline" v-for="item in categories" track-by="$index">
        <input type="checkbox" @change="fetchList()" v-model="search.catalog" :value="item">{{item}}
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;青春路线
      <label class="checkbox-inline" v-for="(key, val) in youthOption" track-by="$index">
        <input type="checkbox" @change="fetchList()" v-model="search.isYouthImplode" :value="key">{{val}}
      </label>
    </div>
    <table class="table-v table table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th>
          #
          </th>
          <th>
            团号
          </th>
          <th>
            简称
          </th>
          <th>
            集合信息
          </th>
          <th>
            状态
          </th>
          <th>
            显示状态
          </th>
          <th>
            是否定制
          </th>
          <th>
            是否青春
          </th>
          <th>
            带队人员
          </th>
          <th>
            出团日期
          </th>
          <th>
            价格
          </th>
          <th>
            编辑
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" track-by="$index" :class="{info: item.id === selectTrip.id}">
          <td>
            【{{item.catalog}}】
          </td>
          <td>
            {{item.alias}}
          </td>
          <td class="text-primary">
            {{item.abbreviation}}
          </td>
          <td>
            {{item.assemblePlace}} {{item.assembleTime}}
          </td>
          <td>
            {{tripStatus[item.status]}}
          </td>
          <td>
            {{tripVisableStatus[item.hide]}}
          </td>
          <td>
            {{tripIsCustom[item.isCustom]}}
          </td>
          <td>
            {{tripIsYouth[item.isYouth]}}
          </td>
          <td>
            {{tripLeaderRole[item.leaderRole]}}
          </td>
          <td>
            {{item.start}}
          </td>
          <td>
            <div v-if="item.priceNow.dailyPrice != null">日常价格: {{item.priceNow.dailyPrice}}</div>
            <div v-if="item.priceNow.onSalePrice != null">当前价格: {{item.priceNow.onSalePrice}}</div>
          </td>
          <td class="relative">
              <button class="btn btn-xs btn-default btn-danger" type="button" @click="click(stopApply)($event, item.id)">截止</button>
              <button class="btn btn-xs btn-default" type="button" @click="showEdit(item)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>&nbsp;基本信息</button>
              <button class="btn btn-xs btn-success" type="button" @click="showEditSize(item)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>&nbsp;人数</button>
              <!-- <button class="btn btn-xs btn-danger" type="button" @click="showEditStatus(item)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>&nbsp;状态</button> -->
              <button type="button" class="btn btn-xs btn-info" @click="showChangePrice(item)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>&nbsp;价格</button>
              <d-popover
              trigger="hover"
              effect="fade"
              placement="left"
              :title="item.title"
              :content="'<b>路线名称:</b>'+item.heading+'<br/>'
            +'<b>简称:</b>'+item.abbreviation+'<br/>'
            +'<b>人数:</b>'+item.size+'<br/>'
            +'<b>状态:</b>'+tripStatus[item.status]+'<br/>'
            +'<b>显示状态:</b>'+tripVisableStatus[item.hide]+'<br/>'
            +'<b>是否定制:</b>'+tripIsCustom[item.isCustom]+'<br/>'
            +'<b>是否青春:</b>'+tripIsYouth[item.isYouth]+'<br/>'
            +'<b>出团日期:</b>'+item.start+'<br/>'
            +'<b>集合信息:</b>'+item.assemblePlace+'&nbsp;'+item.assembleTime+'<br/>'
            +'<b>截至报名时间:</b>'+item.stopTime+'<br/>'
        ">
              <button class="btn btn-xs btn-success"><span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>&nbsp;详情</button>
            </d-popover>
          </td>
        </tr>
      </tbody>
    </table>
    <nav class="text-center">
      <ul class="pagination">
        <li v-for="item in totalPage" track-by="$index" :class="{active: $route.query.page == $index + 1}">
          <a href="javascript:void(0);" @click="page($index + 1)">{{$index+1}}</a>
        </li>
      </ul>
    </nav>
    <trip-edit :show.sync="isShowEdit" :trip.sync="selectTrip" @callback="fetchList"></trip-edit>
    <trip-edit-status :show.sync="isShowEditStatus" :trip.sync="selectTrip" @callback="fetchList"></trip-edit-status>
    <trip-edit-size :show.sync="isShowEditSize" :trip.sync="selectTrip" @callback="fetchList"></trip-edit-size>
    <trip-change-price :show.sync="isShowChangePrice" :trip.sync="selectTrip" @callback="fetchList"></trip-change-price>
  </div>
</template>

<script>
  import TripEdit from './Edit'
  import { popover } from 'vue-strap'
  import TripEditStatus from './EditStatus'
  import TripEditSize from './EditSize'
  import TripChangePrice from './ChangePrice'

  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import { cloneDeep } from 'lodash'

  export default {
    components: {
      TripEdit,
      TripChangePrice,
      TripEditStatus,
      TripEditSize,
      DPopover: popover
    },
    data () {
      return {
        search: {
          status: [],
          catalog: [],
          isYouthImplode: []
        },
        searchConfig: {
          1: '在售',
          2: '已取消',
          3: '已下架',
          4: '已结束'
        },
        list: [],
        isShowEdit: false,
        isShowEditStatus: false,
        isShowEditSize: false,
        isShowChangePrice: false,
        selectTrip: {},
        tripStatus: config.tripStatus,
        tripVisableStatus: config.tripVisableStatus,
        tripIsCustom: config.tripIsCustom,
        tripIsYouth: config.tripIsYouth,
        tripLeaderRole: config.tripLeaderRole,
        categories: config.categories,
        youthOption: ['否', '是'],
        totalPage: 1
      }
    },
    methods: {
      page (index) {
        this.$route.router.go({
          query: Object.assign({}, this.$route.query, {page: index})
        })
      },
      fetchList () {
        let params = Object.assign({
          paginate: 'yes',
          page: this.$route.query.page || 1,
          status: this.search.status.join(','),
          catalog: this.search.catalog.join(','),
          isYouthImplode: this.search.isYouthImplode.join(',')
        }, {
          routeId: this.$route.query.routeId
        })
        return this.$http.get(`${config.apiWe}/product/trip`, params)
          .then(({data}) => {
            this.$set('list', data.list)
            this.$set('totalPage', data.totalPage)
          })
      },
      stopApply (tripId) {
        if (window.confirm('确定截止报名?')) {
          return this.$http.put(`${config.apiWe}/product/trip/${tripId}/stopAccept`)
            .then(() => {
              this.fetchList()
            })
        }
      },
      showChangePrice (trip) {
        this.selectTrip = cloneDeep(trip)
        this.isShowChangePrice = true
      },
      showEdit (trip) {
        this.selectTrip = cloneDeep(trip)
        this.isShowEdit = true
      },
      showEditStatus (trip) {
        this.selectTrip = cloneDeep(trip)
        this.isShowEditStatus = true
      },
      showEditSize (trip) {
        this.selectTrip = cloneDeep(trip)
        this.isShowEditSize = true
      },
      showDetail (trip) {
      },
      click: utils.click
    },
    route: {
      data () {
        return this.fetchList()
      }
    }
  }
</script>

<style>
  .relative {
    position: relative;
  }
  .fadein-transition {
    display: block;
  }
  .popover-content{
    max-width:300px
  }
</style>
<style scoped>
  .search {
    margin-bottom: 20px;
  }
</style>



/** WEBPACK FOOTER **
 ** List.vue?06aa919a
 **/